import { Endpoints } from '@/remote/endpoints'
import { Button } from '@/view/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/view/components/ui/dropdown-menu'
import { Eye, MoreHorizontal, Trash2, UserPen } from 'lucide-react'
import { useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table'
import { DialogDelete } from '../modals/modal-delete'
import { DialogDetailClient } from '../modals/modal-detail-client'
import { DialogEditClient } from '../modals/modal-edit-client'
import { formatCPF } from '../utils/formatDocuments'
import { formatPhone } from '../utils/formatPhone'
import { ClientFormData } from '../validators/client-validator'
import { Badge } from './ui/badge'
import { ScrollArea } from './ui/scroll-area'

type TableClientProps = {
  data: ClientFormData[]
  height?: string
  getRefreshList?: () => void
}

export function TableClient({ data, height, getRefreshList }: TableClientProps) {
  const [dialogEdit, setDialogEdit] = useState(false)
  const [dialogDelete, setDialogDelete] = useState(false)
  const [dialogDetail, setDialogDetail] = useState(false)
  const [dataId, setDataId] = useState(0)

  const openDialogEdit = (id: number) => {
    setDataId(id)
    setDialogEdit(true)
  }

  const closeDialogEdit = () => {
    setDialogEdit(false)
  }

  const openDialogDelete = (id: number) => {
    setDataId(id)
    setDialogDelete(true)
  }

  const closeDialogDelete = () => {
    setDialogDelete(false)
  }

  const openDialogDetail = (id: number) => {
    setDataId(id)
    setDialogDetail(true)
  }

  const closeDialogDetail = () => {
    setDialogDetail(false)
  }

  const status = {
    '0': 'deletado',
    '1': 'ativo',
    '2': 'pendente',
    '3': 'block'
  }

  const statusColor = {
    '0': 'bg-red-200 border-red-300',
    '1': 'bg-green-200 border-green-300',
    '2': 'bg-yellow-200 border-yellow-300',
    '3': 'bg-gray-200 border-gray-300'
  }

  return (
    <div className={'overflow-y-auto' + height}>
      {dialogEdit && <DialogEditClient updateList={getRefreshList} closeDialog={closeDialogEdit} id={dataId} isOpen={dialogEdit} />}
      {dialogDelete && <DialogDelete updateList={getRefreshList} closeDialog={closeDialogDelete} id={dataId} isOpen={dialogDelete} url={Endpoints.client} label="Cliente" />}
      {dialogDetail && <DialogDetailClient id={dataId} closeDialog={closeDialogDetail} isOpen={dialogDetail} />}
      <ScrollArea className="m-4 h-container-members-list relative">
        <Table className="border-none">
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              {/* <TableHead>Status</TableHead> */}
              <TableHead>Nome</TableHead>
              <TableHead>CPF</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Telefone</TableHead>
              <TableHead>Situação</TableHead>

              <TableHead>Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((client: ClientFormData, position: number) => (
              <TableRow key={position} className="text-gray-600">
                <TableCell>{client?.id || 'Sem Id'}</TableCell>
                {/* <TableCell>{client.status ? 'Ativo' : 'Desativado'}</TableCell> */}
                <TableCell className="flex gap-2 capitalize cursor-pointer text-acelerafit-gray-dark hover:text-cashfit-green-200" onClick={() => openDialogDetail(client?.id || 0)}>
                  {client.nome}
                </TableCell>
                <TableCell>{formatCPF(client?.cpf)}</TableCell>
                <TableCell>{client.email}</TableCell>
                <TableCell>{formatPhone(client?.telefone)}</TableCell>
                <TableCell>
                  <Badge variant={'outline'} className={statusColor[(client?.status || 0).toString() as keyof typeof statusColor]}>
                    {status[(client?.status || 0).toString() as keyof typeof status]}
                  </Badge>
                </TableCell>
                <TableCell>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <span className="sr-only">Abrir Menu</span>
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="center">
                      <DropdownMenuLabel>Ações</DropdownMenuLabel>
                      <DropdownMenuItem className="flex gap-2 cursor-pointer" onClick={() => openDialogDetail(client?.id || 0)}>
                        <Eye height={24} width={30} className="text-blue-500 cursor-pointer p-1 hover:text-blue-400" />
                        Detalhes
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem className="flex gap-2 cursor-pointer" onClick={() => openDialogEdit(client?.id || 0)}>
                        <UserPen height={24} width={30} className="text-blue-500 cursor-pointer p-1 hover:text-blue-400" />
                        Editar
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem className="flex gap-2 cursor-pointer" onClick={() => openDialogDelete(client?.id || 0)}>
                        <Trash2 height={24} width={30} className="text-red-500 cursor-pointer p-1 hover:text-red-400" />
                        Apagar
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  )
}
